import type { TypedObject } from '@portabletext/types';
import { JsonLd } from './JsonLd';
import { createFAQPageSchema, extractTextFromPortableText } from './schemas';

export type FAQ = {
  question: string;
  answer: TypedObject[] | string;
};

interface FAQJsonLdProps {
  faqs: FAQ[];
}

/**
 * FAQ 结构化数据组件
 * 用于 Sanity 等 CMS 数据源的 FAQ JSON-LD 注入，自动处理 PortableText → 纯文本转换
 */
export function FAQJsonLd({ faqs }: FAQJsonLdProps) {
  if (!faqs || faqs.length === 0) {
    return null;
  }

  return (
    <JsonLd
      schema={createFAQPageSchema({
        questions: faqs.map((faq) => ({
          question: faq.question,
          answer: Array.isArray(faq.answer)
            ? extractTextFromPortableText(faq.answer)
            : typeof faq.answer === 'string'
              ? faq.answer
              : '',
        })),
      })}
    />
  );
}
